import React from 'react'
import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'Himachal Yatra'
const SITE_URL = 'https://www.himachalyatra.com'
const DEFAULT_IMAGE = `${SITE_URL}/static/og-default.jpg`
const DEFAULT_DESCRIPTION =
  'Book curated tour packages, adventure activities, hotels, and travel services in Himachal Pradesh. Explore Shimla, Manali, Dharamshala, Spiti Valley and more with Himachal Yatra.'

/**
 * Reusable SEO component for per-page meta tags.
 * Handles title, description, canonical, OG, Twitter Cards, and JSON-LD.
 */
const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  keywords,
  noindex = false,
  structuredData,
  children,
}) => {
  const pageTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} - Best Tour Packages in Himachal Pradesh`
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : undefined

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      {structuredData &&
        (Array.isArray(structuredData) ? (
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        ))}

      {children}
    </Helmet>
  )
}

export { SITE_NAME, SITE_URL, DEFAULT_IMAGE, DEFAULT_DESCRIPTION }
export default SEO
